module.exports = __webpack_public_path__ + "static/media/pic_ka_sj.27890136.png";